export default __webpack_public_path__ + "static/char-s-07-kr-667c16decf6b5a9e9b0823c6ff6fd046.png";